import { Button } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { openSendShipmentToAkadPopup, selectShipment, selectShipmentSendingToAkadStatus, sendShipmentToAkad } from "../shipmentSlice"
import WhiteSpinner from "../../../components/loaders/WhiteSpinner"
import { useTranslation } from "react-i18next"
import { COURIER_DELIVERY_TYPE } from "../../../data/static-data"

const SendToAkadButton = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const shipment = useSelector(selectShipment)
    const status = useSelector(selectShipmentSendingToAkadStatus)
    
    const handleSendToAkadButton = () => {
        if(!shipment?.id) return
        dispatch(openSendShipmentToAkadPopup({shipmentID: shipment.id}))
    }

  return (
    <div className="mt-10 text-right">                
        <Button
            variant="contained"
            sx={{
                width: "fit-content",
                color: "white",
                bgcolor: "#059669",
                fontSize: "0.7rem",
                padding: "0.5rem 1rem",
                minWidth: "200px",
                ":hover": {
                    bgcolor: "#047857",
                },
            }}
            onClick={handleSendToAkadButton}
        >
            {
                status === "pending" && <WhiteSpinner />
            }
            {
                status !== "pending" &&
                shipment["getting-package-type"] === COURIER_DELIVERY_TYPE ?
                t("shipment.call_courier_button") :
                t("shipment.send_shipment")
            }
        </Button>
    </div>
  )
}

export default SendToAkadButton